import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { HeroSection } from '../sections/HeroSection';
import { EmotionalOpening } from '../sections/EmotionalOpening';
import { ProblemSolution } from '../sections/ProblemSolution';
import { WhatsInside } from '../sections/WhatsInside';
import { Bonuses } from '../sections/Bonuses';
import { EmotionalClosing } from '../sections/EmotionalClosing';
import { Testimonials } from '../sections/Testimonials';
import { FAQ } from '../sections/FAQ';
import { FinalCTA } from '../sections/FinalCTA';
export function ProductPage() {
  return <div className="min-h-screen flex flex-col" data-id="element-87">
      <Header data-id="element-88" />
      <main className="flex-grow" data-id="element-89">
        <HeroSection data-id="element-90" />
        <EmotionalOpening data-id="element-91" />
        <ProblemSolution data-id="element-92" />
        <WhatsInside data-id="element-93" />
        <Bonuses data-id="element-94" />
        <EmotionalClosing data-id="element-95" />
        <Testimonials data-id="element-96" />
        <FAQ data-id="element-97" />
        <FinalCTA data-id="element-98" />
      </main>
      <Footer data-id="element-99" />
    </div>;
}